import { S as Spinner, d as defineCustomElement$1 } from './spinner.js';

const TtSpinner = Spinner;
const defineCustomElement = defineCustomElement$1;

export { TtSpinner, defineCustomElement };
